import {
    TRANSACTIONS_DETAILS_OPEN_MODAL,
    TRANSACTIONS_DETAILS_CLOSE_MODAL,
    TRANSACTIONS_DETAILS_RESULT_REQUEST,
    TRANSACTIONS_DETAILS_RESULT_RESULT
} from 'Redux/actionTypes';

export const transactionsDetailsOpenModal = (transactionId, type) => ({
    type: TRANSACTIONS_DETAILS_OPEN_MODAL,
    payload: {transactionId, type}
})

export const transactionsDetailsCloseModal = () => ({
    type: TRANSACTIONS_DETAILS_CLOSE_MODAL
})

export const transactionsDetailsRequest = (filters) => ({
    type: TRANSACTIONS_DETAILS_RESULT_REQUEST,
    payload: filters,
})

export const transactionsDetailsResult = (result) => ({
    type: TRANSACTIONS_DETAILS_RESULT_RESULT,
    payload: result,
})